import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
// import PreviewBanner from './components/PreviewBanner';
// import DebugEnvironment from './components/DebugEnvironment';
import AppRoutes from './components/AppRoutes';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
// import ThemeSelector from './components/ui/ThemeSelector';
import { EllafinThemeProvider } from './contexts/ThemeContext';

/**
 * Main application component that orchestrates the EllaFin website
 *
 * This component manages:
 * - Error boundary for graceful error handling
 * - Theme provider with 6-theme switcher system (includes CssBaseline)
 * - Router setup with scroll-to-top functionality
 * - Floating theme selector available on all pages
 * - Delegates all routing logic to AppRoutes component
 *
 * @returns {React.ReactElement} The main application with routing
 */
function App() {
  return (
    <ErrorBoundary>
      <EllafinThemeProvider>
        {/* <PreviewBanner />
        <DebugEnvironment /> */}
        <Router>
          <ScrollToTop />
          <AppRoutes />
        </Router>
        {/* <ThemeSelector /> */}
      </EllafinThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
